import type {
  Session,
  Payment,
  SessionDetail,
} from '../types';

// Dashboard-specific mocks have been removed - use Apollo queries instead

export const MOCK_FULL_SESSIONS: Session[] = [
  {
    id: '1',
    time: '9:00',
    duration: 60,
    format: 'Office',
    client: { name: 'Margaret Chen', initials: 'MC', note: 'Returning · 4 sessions' },
    matter: 'Estate planning',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 600,
    whenLabel: 'Today · 09:00',
    whenDetail: 'In 1 hour',
  },
  {
    id: '2',
    time: '10:30',
    duration: 30,
    format: 'Video',
    client: { name: 'Aaron Taylor', initials: 'AT', note: 'First time · referred by MC' },
    matter: 'Business formation',
    provider: 'Sarah Levy',
    status: 'awaiting',
    fee: 300,
    whenLabel: 'Today · 10:30',
    whenDetail: 'In 2.5 hours',
  },
  {
    id: '3',
    time: '12:00',
    duration: 90,
    format: 'Office',
    client: {
      name: 'Jasmine Park',
      initials: 'JP',
      isNew: true,
      note: 'Intake complete · flagged urgent',
    },
    matter: 'Contract review',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 1200,
    highlight: true,
    whenLabel: 'Today · 12:00',
    whenDetail: 'In 2 hours',
  },
  {
    id: '4',
    time: '14:00',
    duration: 45,
    format: 'Video',
    client: { name: 'Robin Whitaker', initials: 'RW', note: 'Returning' },
    matter: 'Follow-up',
    provider: 'Sarah Levy',
    status: 'needs-action',
    fee: 450,
    alertNote: 'Payment failed · retry at 12:00',
    whenLabel: 'Today · 14:00',
    whenDetail: 'In 4 hours',
  },
  {
    id: '5',
    time: '16:30',
    duration: 60,
    format: 'Office',
    client: { name: 'Derek Nam', initials: 'DN', note: 'Returning · 2 sessions' },
    matter: 'IP consultation',
    provider: 'David Reinhart',
    status: 'awaiting',
    fee: 800,
    whenLabel: 'Today · 16:30',
    whenDetail: 'In 6 hours',
  },
  {
    id: '6',
    time: '9:30',
    duration: 60,
    format: 'Office',
    client: { name: 'Tom Abernathy', initials: 'TA', note: 'Returning · 7 sessions' },
    matter: 'Trust review',
    provider: 'Sarah Levy',
    status: 'confirmed',
    fee: 600,
    whenLabel: 'Apr 22 · 09:30',
    whenDetail: 'Yesterday',
  },
  {
    id: '7',
    time: '11:00',
    duration: 90,
    format: 'Office',
    client: { name: 'Cal Harrington', initials: 'CH', note: 'Returning' },
    matter: 'IP consultation',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 900,
    whenLabel: 'Apr 22 · 11:00',
    whenDetail: 'Yesterday',
  },
  {
    id: '8',
    time: '10:30',
    duration: 60,
    format: 'Video',
    client: { name: 'James Tuohy', initials: 'JT', note: 'Returning' },
    matter: 'Follow-up',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 500,
    whenLabel: 'Apr 22 · 10:30',
    whenDetail: 'Yesterday',
  },
  {
    id: '9',
    time: '10:00',
    duration: 90,
    format: 'Office',
    client: { name: 'Kira Boyd', initials: 'KB', note: 'Refund issued · rescheduled' },
    matter: 'Tax planning',
    provider: 'Marcus Okafor',
    status: 'scheduled',
    fee: 450,
    whenLabel: 'Apr 21 · 10:00',
    whenDetail: '2 days ago',
  },
  {
    id: '10',
    time: '9:00',
    duration: 60,
    format: 'Office',
    client: { name: 'Nicole Ford', initials: 'NF', note: 'Returning · 4 sessions' },
    matter: 'Business formation',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 750,
    whenLabel: 'Apr 24 · 09:00',
    whenDetail: 'Tomorrow',
  },
  {
    id: '11',
    time: '11:30',
    duration: 60,
    format: 'Video',
    client: { name: 'Elena Ramirez', initials: 'ER', note: 'Payment retry pending' },
    matter: 'Tax planning',
    provider: 'Marcus Okafor',
    status: 'awaiting',
    fee: 700,
    whenLabel: 'Apr 24 · 11:30',
    whenDetail: 'Tomorrow',
  },
  {
    id: '12',
    time: '13:00',
    duration: 90,
    format: 'Office',
    client: { name: 'Liam Carter', initials: 'LC', note: 'New intake' },
    matter: 'Intake consult',
    provider: 'David Reinhart',
    status: 'scheduled',
    fee: 0,
    whenLabel: 'Apr 21 · 13:00',
    whenDetail: '2 days ago',
  },
  {
    id: '13',
    time: '14:00',
    duration: 60,
    format: 'Office',
    client: { name: 'Priya Krishnan', initials: 'PK', note: 'Returning' },
    matter: 'Contract drafting',
    provider: 'Marcus Okafor',
    status: 'confirmed',
    fee: 600,
    whenLabel: 'Apr 22 · 14:00',
    whenDetail: 'Yesterday',
  },
  {
    id: '14',
    time: '15:00',
    duration: 90,
    format: 'Video',
    client: { name: 'Heather Lin', initials: 'HL', note: 'Returning' },
    matter: 'IP consultation',
    provider: 'David Reinhart',
    status: 'confirmed',
    fee: 900,
    whenLabel: 'Apr 22 · 15:00',
    whenDetail: 'Yesterday',
  },
  {
    id: '15',
    time: '14:30',
    duration: 60,
    format: 'Office',
    client: { name: 'Tom Abernathy', initials: 'TA', note: 'Returning' },
    matter: 'Trust review',
    provider: 'Sarah Levy',
    status: 'confirmed',
    fee: 600,
    whenLabel: 'Apr 24 · 14:30',
    whenDetail: 'Tomorrow',
  },
];

export const MOCK_SESSION_DETAIL: SessionDetail = {
  id: '3',
  time: '12:00',
  duration: 90,
  format: 'Office',
  client: {
    name: 'Jasmine Park',
    initials: 'JP',
    isNew: true,
    note: 'Intake complete · flagged urgent',
  },
  matter: 'Contract review',
  provider: 'David Reinhart',
  status: 'confirmed',
  fee: 1200,
  highlight: true,
  description:
    "Review of a SaaS master services agreement that Jasmine's team received from a prospective enterprise customer last week. She's flagged termination and IP assignment clauses as concerns.",
  room: 'Conference B',
  dateLabel: 'Thursday, April 23 · 90 minutes',
  timeRange: '12:00 – 1:30 PM',
  startsIn: 'Starts in 2h 18m',
  checklist: [
    { label: 'Client intake completed', done: true, doneAt: 'Apr 23, 8:24 AM' },
    {
      label: 'Engagement letter signed',
      done: true,
      doneAt: 'Apr 23, 9:03 AM · v3.4',
      linkLabel: 'View',
    },
    {
      label: 'Retainer received',
      done: true,
      doneAt: 'Apr 23, 9:42 AM · see payment',
      linkLabel: 'View',
    },
    { label: 'Review contract (3 docs attached)', done: false, doneAt: 'Provider prep · allow 20 min' },
    { label: 'Confirm client intake notes with David', done: false, doneAt: 'Quick sync · optional' },
  ],
  clientBrief: {
    need:
      "\"Our team at Kinetic got an MSA draft from Northstar Industries (a Fortune 500 we're trying to land). We need someone to go through it before we sign. I'm mainly worried about the IP assignment and termination clauses — they feel aggressive to me but I could be wrong.\"",
    matterType: 'Contract review',
    urgency: 'Decision by Monday',
    referredBy: 'Margaret Chen',
  },
  files: [
    {
      id: 'f1',
      name: 'Northstar-MSA-v3-clean.pdf',
      description: 'Master agreement · 42 pages · 1.8 MB',
      size: '1.8 MB',
      uploadedAgo: 'uploaded 4h ago',
      variant: 'rust',
    },
    {
      id: 'f2',
      name: 'Northstar-DPA-exhibit-a.pdf',
      description: 'Data processing addendum · 8 pages · 420 KB',
      size: '420 KB',
      uploadedAgo: 'uploaded 4h ago',
      variant: 'rust',
    },
    {
      id: 'f3',
      name: 'Engagement-letter-signed.pdf',
      description: 'Signed agreement · 3 pages · 180 KB',
      size: '180 KB',
      uploadedAgo: '3h ago',
      variant: 'sage',
    },
  ],
  notes: [
    {
      id: 'n1',
      provider: { name: 'David Reinhart', initials: 'DR' },
      timeAgo: '3 hours ago',
      content:
        'Did a quick first pass on the MSA. Section 8 (IP assignment) is unusually broad — assigns all pre-existing IP touched during engagement. Will push back. Section 11 (termination for convenience) gives Northstar 10-day out with no kill fee; industry standard is 60-90 days. Both worth flagging to Jasmine early.',
    },
    {
      id: 'n2',
      provider: { name: 'David Reinhart', initials: 'DR' },
      timeAgo: '1 hour ago',
      content:
        "Cross-referenced Northstar's public filings — they've used the same base MSA template with three other vendors in the past 18 months. Two got IP carve-outs, one didn't. Leverage available.",
    },
  ],
  timeline: [
    {
      id: 't1',
      type: 'session',
      title: 'Session scheduled',
      detail: 'Contract review · 90 min · David Reinhart',
      timeAgo: '2 hours ago',
      dotColor: 'bg-tide',
    },
    {
      id: 't2',
      type: 'payment',
      title: 'Payment received · $1,200',
      detail: 'Card ending 4112',
      timeAgo: '2 hours ago',
      dotColor: 'bg-sage',
    },
    {
      id: 't3',
      type: 'agreement',
      title: 'Agreement signed',
      detail: 'Engagement letter · v3.4',
      timeAgo: '3 hours ago',
      dotColor: 'bg-spark',
    },
    {
      id: 't4',
      type: 'created',
      title: 'Client created',
      detail: 'Intake completed from web',
      timeAgo: '4 hours ago',
      dotColor: 'bg-ink-5',
    },
  ],
  clientDetail: {
    name: 'Jasmine Park',
    initials: 'JP',
    email: 'jpark@kinetic.co',
    phone: '(415) 555-0178',
    company: 'Kinetic, Inc · Founder',
    sessions: 1,
    memberSince: 'member since today',
    isNew: true,
  },
  providerDetail: {
    name: 'David Reinhart',
    initials: 'DR',
    specialties: 'Estate · IP · Family',
    availability: "David has 3 sessions today · he's available by 11:45 if you need to reach him.",
  },
};

export const MOCK_PAYMENTS: Payment[] = [
  {
    id: 'p1',
    date: 'Apr 23 · 06:40',
    dateRelative: 'Retry at 12:00',
    client: { name: 'Robin Whitaker', initials: 'RW' },
    sessionRef: 'Follow-up · 2:00 PM · Sarah',
    amount: 450,
    status: 'failed',
    method: 'Card · 4112',
    retryNote: 'Retry at 12:00',
  },
  {
    id: 'p2',
    date: 'Apr 22 · 18:15',
    dateRelative: 'Retry at 12:00',
    client: { name: 'Elena Ramirez', initials: 'ER' },
    sessionRef: 'Tax planning · Apr 24 · Marcus',
    amount: 300,
    status: 'failed',
    method: 'Card · 8847',
    retryNote: 'Retry at 12:00',
  },
  {
    id: 'p3',
    date: 'Apr 23 · 09:42',
    dateRelative: '2 hours ago',
    client: { name: 'Jasmine Park', initials: 'JP' },
    sessionRef: 'Contract review · 12:00 PM · David',
    amount: 1200,
    status: 'paid',
    method: 'Card · 4112',
  },
  {
    id: 'p4',
    date: 'Apr 22 · 15:22',
    dateRelative: 'Yesterday',
    client: { name: 'Tom Abernathy', initials: 'TA' },
    sessionRef: 'Trust review · Apr 24 · Sarah',
    amount: 900,
    status: 'paid',
    method: 'Card · 0094',
  },
  {
    id: 'p5',
    date: 'Apr 22 · 11:03',
    dateRelative: 'Yesterday',
    client: { name: 'Margaret Chen', initials: 'MC' },
    sessionRef: 'Estate planning · Apr 23 · David',
    amount: 600,
    status: 'paid',
    method: 'Bank · ••1156',
  },
  {
    id: 'p6',
    date: 'Apr 21 · 16:48',
    dateRelative: '2 days',
    client: { name: 'Nicole Ford', initials: 'NF' },
    sessionRef: 'Business formation · Apr 25 · David',
    amount: 750,
    status: 'paid',
    method: 'Card · 5562',
  },
  {
    id: 'p7',
    date: 'Apr 20 · 10:15',
    dateRelative: '3 days',
    client: { name: 'Derek Nam', initials: 'DN' },
    sessionRef: 'IP consultation · Apr 23 · David',
    amount: 800,
    status: 'paid',
    method: 'Card · 2048',
  },
  {
    id: 'p8',
    date: 'Apr 18 · 13:24',
    dateRelative: '5 days',
    client: { name: 'Cal Harrington', initials: 'CH' },
    sessionRef: 'IP consultation · Apr 22 · David',
    amount: 900,
    status: 'paid',
    method: 'Card · 9903',
  },
  {
    id: 'p9',
    date: 'Apr 16 · 09:50',
    dateRelative: '7 days',
    client: { name: 'Kira Boyd', initials: 'KB' },
    sessionRef: 'Tax planning · Apr 21 · Marcus',
    amount: 450,
    status: 'refunded',
    method: 'Card · 7761',
  },
  {
    id: 'p10',
    date: 'Apr 15 · 14:02',
    dateRelative: '8 days',
    client: { name: 'Yusuf Kane', initials: 'YK' },
    sessionRef: 'IP consultation · Apr 25 · Sarah',
    amount: 800,
    status: 'paid',
    method: 'Card · 3388',
  },
];
